import type { VariantProps } from 'class-variance-authority';
import type { ElementType } from 'react';
import { cva } from 'class-variance-authority';

const buttonStyles = cva(
  [
    'items-center',
    'select-none',
    'box-border',
    '::before:box-border',
    '::after:box-border',
    'flex',
    'flex-row',
    'flex-shrink-0',
    'min-w-fit',
    'justify-center',
    'focus:outline-none',
    'focus-visible:ring-button-focus',
    'transition-colors',
    'duration-100',
    'ease-in-out',
    'whitespace-nowrap',
    'disabled:cursor-not-allowed',
    'data-[state=loading]:cursor-wait',
  ],
  {
    variants: {
      variant: {
        filled: '',
        muted: '',
        ghost: 'bg-transparent',
        dashed: [
          'border-dashed border-button-dashed border-button hover:border-button-dashed-hover active:border-button-dashed-press disabled:border-button-dashed-disabled',
          'bg-button-dashed hover:bg-button-dashed-hover',
          'active:bg-button-dashed-press disabled:bg-button-dashed-disabled disabled:text-button-onneutral-muted-disabled',
          'data-[state=loading]:bg-button-dashed-loading',
        ],
      },

      mutedText: {
        true: '!text-button-onneutral-muted-tertiary hover:!text-button-onneutral-muted-primary',
      },

      blurEffect: {
        true: 'backdrop-blur',
      },

      color: {
        default: '',
        cta: '',
        destructive: [
          'bg-button-destructive-muted border border-button-destructive text-button-ondestructive-muted-primary',
          'hover:bg-button-destructive-muted-hover hover:border-button-destructive-hover',
          'active:bg-button-destructive-muted-press active:border-button-destructive-press',
          'disabled:text-button-ondestructive-muted-disabled disabled:bg-button-destructive-muted-disabled disabled:border-transparent',
        ],
      },

      size: {
        xs: 'h-button-xs px-button-xs rounded-button-xs button-xs gap-button-xs',
        sm: 'h-button-sm px-button-sm rounded-button-sm button-sm gap-button-sm',
        md: 'h-button-md px-button-md rounded-button-md button-md gap-button-md',
        lg: 'h-button-lg px-button-lg rounded-button-lg button-lg gap-button-lg',
        xl: 'h-button-xl px-button-xl rounded-button-xl button-xl gap-button-xl',
      },
    },
    defaultVariants: {
      variant: 'filled',
      color: 'default',
      size: 'md',
    },
  },
);

export type BannerProps = {
  title?: string;
  description?: string;
  actionLabel?: string;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  href?: string;
  as?: ElementType;
} & VariantProps<typeof buttonStyles>;
